import * as React from 'react';
import {styled} from '../../utils';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbItemRenderer from './private/BreadcrumbItemRenderer';
import {BreadcrumbProps, BreadcrumbItemRendererProps} from './types';

const Root = styled('nav')({
  display: 'block'
});

export default class Breadcrumb extends React.Component<BreadcrumbProps, {}> {
  public static defaultProps = {
    separator: '>'
  };

  public render() {
    const items = React.Children.map(this.props.children, (child, index) => {
      if (React.isValidElement(child) && child.type === BreadcrumbItem) {
        const rendererProps = {
          separator: this._getItemSeparator(index),
          current: this._isCurrentItem(index),
          ...child.props
        };
        return <BreadcrumbItemRenderer {...rendererProps as BreadcrumbItemRendererProps} />;
      }
      return null;
    });

    return <Root {...this.props}>{items}</Root>;
  }

  private get _numberOfItems() {
    return React.Children.count(this.props.children);
  }

  private _isCurrentItem = (index: number) => this._numberOfItems - 1 === index;

  private _getItemSeparator = (index: number) => (!this._isCurrentItem(index) ? this.props.separator : null);
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.tsx